<script>
/**
 * ****************************************************************************
 * @description     :   Pagination Component (minimal « 1 »)
 * @created at      :   2024/05/22
 * @updated at      :   2025/11/07
 * ****************************************************************************
 */
import template from './template.html';
import './style.scss';

var PtjAnsPagination = {
    template: template,
    name: 'PtjAnsPagination',
    props: {
        customClass: String,
        customSelectClass: { type: [String, Object], default: '' },
        isDisabled: Boolean,
        pageSize: { type: [String, Number], default: 20 },
        totalRows: { type: [String, Number], default: 0 },
        pageNo: { type: Number, default: 1 },
        pageCollapse: { type: Boolean, default: false },
        selectBox: Boolean,
        optionPageSize: {
            type: Array,
            default: () => {
                return [
                    {
                        code: 20,
                        name: '20件'
                    },
                    {
                        code: 50,
                        name: '50件'
                    },
                    {
                        code: 100,
                        name: '100件'
                    }
                ];
            }
        },
        optionsStyle: {
            type: Object,
            default() {
                return { pageSize: { wrapClass: '' } };
            }
        }
    },
    data() {
        return {
            currentPage: this.pageNo,
            internalRowStart: 1,
            internalRowEnd: 0
        };
    },
    computed: {
        totalRowsNum() {
            return Number(this.totalRows) || 0;
        },
        perPageActual() {
            const n = Number(this.pageSize);
            return isNaN(n) ? 20 : n;
        },
        selectClass() {
            const baseClasses = {
                'item-component': false
            };

            if (typeof this.customSelectClass === 'object' && this.customSelectClass !== null) {
                return { ...baseClasses, ...this.customSelectClass };
            } else if (typeof this.customSelectClass === 'string' && this.customSelectClass) {
                return { ...baseClasses, [this.customSelectClass]: true };
            }

            return baseClasses;
        }
    },
    created() {
        this.recalculateWindow();
    },
    mounted() {},
    updated() {},
    watch: {
        pageNo(val) {
            if (val) this.currentPage = val;
        },
        pageSize() {
            this.currentPage = 1;
            this.emitChange();
            this.recalculateWindow();
        },
        totalRows() {
            this.recalculateWindow();
        },
        currentPage() {
            this.recalculateWindow();
            this.emitChange();
        }
    },
    methods: {
        emitChange() {
            this.$emit('changePage', {
                currentPage: this.currentPage,
                perPage: this.perPageActual
            });
        },
        recalculateWindow() {
            const per = this.perPageActual;
            const cur = this.currentPage;
            const total = this.totalRowsNum;

            if (total === 0) {
                this.internalRowStart = 0;
                this.internalRowEnd = 0;
                return;
            }
            const start = (cur - 1) * per + 1;
            let end = cur * per;
            if (end > total) end = total;

            this.internalRowStart = start;
            this.internalRowEnd = end;
        }
    }
};
export default PtjAnsPagination;
</script>
